import actions from '../action/colleaguesBuyShare'
import CONSTANT from '../constant/colleaguesBuyShare'
import { Toast } from 'mint-ui'
import _ from 'underscore'

export default {
  actions,
  state: {
    colleaguesBuyShareInfo: {},
    colleaguesBuyShareProductList: {},
    communityList: []
  },
  getters: {

  },
  mutations: {
    [CONSTANT.COLLEAGUESBUYSHARE_GETGROUPINFO_SUCCESS](state, data) {
      state.colleaguesBuyShareInfo = data
    },
    [CONSTANT.COLLEAGUESBUYSHARE_GETGROUPINFO_ERROR](state, e) {

    },
    [CONSTANT.COLLEAGUESBUYSHARE_GETPRODUCTLIST_SUCCESS](state, data) {
      state.colleaguesBuyShareProductList = data
    },
    [CONSTANT.COLLEAGUESBUYSHARE_GETPRODUCTLIST_ERROR](state, e) {

    },
    [CONSTANT.COLLEAGUESBUYSHARE_GET_COMMUNITY_LIST_SUCCESS](state, data) {
      state.communityList = data.list
    },
    [CONSTANT.COLLEAGUESBUYSHARE_GET_COMMUNITY_LIST_ERROR](state, e) {
      state.communityList = []
    },
  }
}
